export enum QueueTypeUrlSuffixes {
  supervisor = 'supervisor',
  identification = 'identify',
  dataEntry = 'data-entry',
  supervisorIdentification = 'supervisor-identify'
}
